<template>
  <button
    type="button"
    class="block w-3/4 text-left text-sm font-medium"
    :class="[
      { 'text-text-positive-primary': color === NoteColor.green },
      { 'text-text-warning-accent': color === NoteColor.orange },
    ]"
  >
    <slot></slot>
    <!-- prettier-ignore -->
    <svg v-if="withIcon" class="inline-block ml-1" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none"><path fill="currentColor" fill-rule="evenodd" d="M13.483 8A5.484 5.484 0 1 1 2.514 8a5.484 5.484 0 0 1 10.97 0ZM8 14.668a6.667 6.667 0 1 0 0-13.333 6.667 6.667 0 0 0 0 13.333Zm0-8.941a.591.591 0 0 0 .583-.584.583.583 0 0 0-1.167 0A.591.591 0 0 0 8 5.726Zm0 5.716a.583.583 0 0 1-.584-.583V7.235A.591.591 0 0 1 8 6.65a.591.591 0 0 1 .583.584v3.624a.583.583 0 0 1-.583.583Z" clip-rule="evenodd"/></svg>
  </button>
</template>

<script setup lang="ts">
  import { NoteColor } from '../../types';

  defineProps<{
    color: NoteColor;
    withIcon?: boolean;
  }>();
</script>
